const appTheme = (state = null, action) => {
  switch (action.type) {
    case "SET_APP_THEME":
      localStorage.setItem("appTheme", action.payload);
      return action.payload;

    default:
      return state;
  }
};

export default appTheme;
